import React from 'react';
import { DataProvider } from '../../contexts/DataContext';
import TaskDetailsPage from './TaskDetailsPage';
import ContactDetailsPage from '../contacts/ContactDetailsPage';

// Right side of the desktop split view (Tasks and Contacts pages)
export const TaskSplitPane = ({ selection, setSelection, onChanged, glance, rootBackLabel }) => {
  if (!selection) return glance;

  const close = () => setSelection(null);
  const selectTask = (id) => setSelection({ type: 'task', id });
  let taskBack;
  if (selection.fromContactId) taskBack = { fn: () => setSelection({ type: 'contact', id: selection.fromContactId }), label: 'Back to contact' };
  else if (selection.fromRoot) taskBack = { fn: close, label: rootBackLabel };

  return (
    <DataProvider>
      {selection.type === 'contact' ? (
        <ContactDetailsPage
          key={`contact-${selection.id}`}
          embedded
          contactId={selection.id}
          onClose={close}
          onBack={selection.fromTaskId ? () => selectTask(selection.fromTaskId) : undefined}
          onSelectTask={(taskId) => setSelection({ type: 'task', id: taskId, fromContactId: selection.id })}
          onChanged={onChanged}
        />
      ) : (
        <TaskDetailsPage
          key={`task-${selection.id}`}
          embedded
          taskId={selection.id}
          onClose={close}
          onBack={taskBack?.fn}
          backLabel={taskBack?.label}
          onSelectTask={selectTask}
          onOpenContact={(contactId) => setSelection({ type: 'contact', id: contactId, fromTaskId: selection.id })}
          onChanged={onChanged}
        />
      )}
    </DataProvider>
  );
};

export default TaskSplitPane;
